import React from "react";
import { missionVisionMotto } from "../../staticData/generalInfo";

function MissionVision() {
  let [mission, ...VisionMotto] = missionVisionMotto;
  return (
    <>
      <section className="about-mission-vision-motto">
        <div className="about-mission">
          <h3>{mission.title}</h3>
          <p>{mission.text}</p>
        </div>

        <div className="about-vision-motto">
          {VisionMotto.map((item, index) => {
            return (
              <div key={`vision-motto-index-${index}`}>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
export default MissionVision;
